import { render, staticRenderFns } from "./apprRequest.vue?vue&type=template&id=6ed50674"
import script from "./apprRequest.vue?vue&type=script&lang=js"
export * from "./apprRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed50674')) {
      api.createRecord('6ed50674', component.options)
    } else {
      api.reload('6ed50674', component.options)
    }
    module.hot.accept("./apprRequest.vue?vue&type=template&id=6ed50674", function () {
      api.rerender('6ed50674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/apprRequest.vue"
export default component.exports